import {
  CERTIFICATION_VIDEO_PAGE_UPDATE_FORM_FIELD,
  CERTIFICATION_VIDEO_PAGE_TRIGGER_REQUEST,
  CERTIFICATION_VIDEO_PAGE_UPDATE_REQUEST_STATE,
  CERTIFICATION_VIDEO_PAGE_RESET_STATE,
} from '../constants/actionTypes';

import {
  REQUEST_UNSTARTED,
  REQUEST_SUCCESS,
  REQUEST_FETCHING,
  REQUEST_ERROR,
} from '../constants/requestStates';

export const resetCertificationVideoPage = () => {
  return {
    type: CERTIFICATION_VIDEO_PAGE_RESET_STATE
  }
};

export const certificationVideoPageTriggerRequest = (key) => {
  return {
    type: CERTIFICATION_VIDEO_PAGE_TRIGGER_REQUEST + key,
    payload: {
      key,
    }
  }
};

export const certificationVideoPageUpdateRequestState = (key, state, result=undefined) => {
  let payload = {
    state,
  };
  if (!!(result)) {
    if (state === REQUEST_SUCCESS || state === REQUEST_FETCHING || state === REQUEST_UNSTARTED) {
      payload.result = result
    }
    if (state === REQUEST_ERROR) {
      payload.error = result;
    }
  }
  return {
    type: CERTIFICATION_VIDEO_PAGE_UPDATE_REQUEST_STATE,
    key,
    payload,
  }
}

export const certificationVideoPageUpdateFormField = (key, value) => {
  return {
    type: CERTIFICATION_VIDEO_PAGE_UPDATE_FORM_FIELD,
    payload: {[key]: value}
  }
};
